// state/cartState.js
import { atom } from "recoil";

export const cartState = atom({
  key: "cartState",
  default: JSON.parse(localStorage.getItem("cartItems")) || [],
});

export const ticketCartCountState = atom({
  key: "ticketCartCountState",
  default: 0,
});

export const POScartState = atom({
  key: "POScartItems",
  default: JSON.parse(localStorage.getItem("POScartItems")) || [],
});